import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AiOutlineCheck } from "react-icons/ai";
import { hideModal } from "../../../actions/modal.action";
import { modalContext } from "../root";

export default function DocumentProcessingRequestModal() {
  const modalData = useContext(modalContext);
  const history = useHistory();
  const dispatch = useDispatch();

  const continueFunc = () => {
    dispatch(hideModal());
    history.push("/dashboard/user/document-processing");
  };

  const returnToSecretariat = () => {
    dispatch(hideModal());
    history.push("/dashboard/user/secretariat");
  };

  return (
    <>
      <div
        className="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center text-center p-4 min-h-full">
            <div className="py-5 relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                {/* <div className="sm:flex sm:items-start"> */}
                <div className="">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                    <AiOutlineCheck className="h-6 w-6 text-green-600" />
                  </div>
                  <div className="mt-3 text-center">
                    <h3
                      className="text-lg leading-6 font-medium text-gray-900"
                      id="modal-title"
                    >
                      Request Successful
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{modalData}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  onClick={() => continueFunc()}
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-800 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Continue
                </button>
                <button
                  onClick={() => returnToSecretariat()}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Return to Secretariat
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
